import { BaseEditModel } from "model/BaseEditModel";
import Produto from "./Produto";
import PlanoInspecao from "model/qualidade/PlanoInspecao";
import EstagioRoteiro from "model/producao/EstagioRoteiro";

export default class ProdutoEstagioPlano implements BaseEditModel {

    id: number;
    key: string | null = "";
    sequencial: number | null = 0;
    produto: Produto | null;
    estagioRoteiro: EstagioRoteiro;
    planoInspecao: PlanoInspecao;

    constructor(
        id = 0,
        produto = null,
        estagioRoteiro = new EstagioRoteiro(),
        planoInspecao = new PlanoInspecao()
    ) {
        this.id = id;
        this.produto = produto;
        this.estagioRoteiro = estagioRoteiro;
        this.planoInspecao = planoInspecao;
    }

}